import { render, staticRenderFns } from "./QuartzEdit.vue?vue&type=template&id=787d413c&scoped=true"
import script from "./QuartzEdit.vue?vue&type=script&lang=js"
export * from "./QuartzEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d413c",
  null
  
)

export default component.exports